export const LocationType = Object.freeze({
  GROUP_ORDER: 'GroupOrder',
  MANAGED_PROPERTY: 'ManagedProperty',
  RESIDENTIAL_COMPLEX: 'ResidentialComplex',
  RESIDENTIAL_HOME: 'ResidentialHome',
  RESIDENTIAL_ZONE: 'ResidentialZone',
  SINGLE_COMPANY: 'SingleCompany',
})
